// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: '选择',
    titleLinkTooltip: '转到页面',
    collapseCardTooltip: '折叠卡片',
    expandCardTooltip: '展开卡片'
  },
  CardList: {
    loadMore: '加载更多',
    notFound: '未找到项目。',
    toolbarSelect: '选择',
    viewCards: '卡片',
    viewTiles: '磁贴',
    viewList: '列表',
    toolbarView: '视图'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: '离开',
    cancel: '返回',
    content: '您确定要关闭并离开此窗口吗？您所做的任何数据更改都不会被保存。'
  },
  Cuttable: {
    showMore: '显示更多',
    showLess: '显示更少'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: '取消'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: '取消'
  },
  Dropdown: {
    close: '关闭'
  },
  Form: {
    submitButton: '保存',
    applyButton: '应用',
    cancelButton: '取消'
  },
  FormField: {
    clear: '清除',
    remove: '移除',
    addMore: '再添加一个',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: '若要提升密码强度：',
    passwordTooShort: '请加长密码。',
    lettersLowerCase: '至少使用一个小写字母。',
    lettersUpperCase: '至少使用一个大写字母。',
    numbers1: '至少使用一个数字。',
    numbers3: '至少使用三个数字。',
    specialChar1: '至少使用一个特殊字符（如：!,@,#,$,%,^,&,*,?,_,~）。',
    specialChar2: '至少使用两个特殊字符（如：!,@,#,$,%,^,&,*,?,_,~）。',
    comboUpperAndLower: '使用大写和小写字符。',
    comboLettersAndNumbers: '使用数字与字符。',
    comboLettersNumbersSpecial: '使用数字、字符与特殊字符。',
    yourPasswordIsStrong: '您可以通过增加长度来提升密码强度。',
    passwordStrength: '密码强度为 %%strength%%。',
    strengthVeryStrong: '非常强',
    strengthStrong: '强',
    strengthVeryWeak: '非常弱',
    strengthWeak: '弱',
    strengthMedium: '中等',
    hidePassword: '隐藏密码',
    showPassword: '显示密码',
    generateButton: '生成',
    copyButtonHint: '复制密码',
    copySuccessToast: '密码已复制',
    generateButtonHint: '生成一个高强度密码'
  },
  InPlaceEdit: {
    cancelButtonHint: '取消修改',
    editButtonHint: '编辑数值',
    okButtonHint: '保存更改'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: '选择文件...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '共计 %%totalRows%% 个项目',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '已选定 %%selectedRows%%（共计： %%totalRows%%）个项目',
    all: '所有',
    allItemsOnPageSelected: '已选定页面上的所有项目',
    allItemsSelected: '已选定所有项目',
    selectAllItems: '所选所有项目',
    selectAllItemsOnPage: '选择页面上的所有项目',
    deselectAll: '取消选定',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: '找不到匹配该过滤器的任何项目',
    emptyTitle: '看来这里什么都没有',
    filteredDescription: '优化查询或从过滤器中移除一些标准，然后重试。'
  },
  ListOperation: {
    cancelButton: '取消'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: '%%total%%',
    itemsPerPage: '每页的项目',
    all: '所有',
    total: '第 %%current%% 页（共计 %%total%% 页）'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: '关闭',
    cancelButton: '取消'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: '无选项',
    placeholder: '选择...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%%（共计 %%total%%）'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: '关闭群组'
  },
  Toast: {
    closeButton: 'Close'
  }
};